import { Link } from "react-router"
import { ArrowUpRight } from "./layout"
import { Eyebrow, GoldPill, PageHero } from "./components"
import { GraduationCapIcon } from "./icons"

type InfoItem = {
  title: string
  body: string
  icon: React.ReactNode
}

const MOBILITY_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M13 16.5C13 19.5376 10.5376 22 7.5 22C4.46243 22 2 19.5376 2 16.5C2 13.4624 4.46243 11 7.5 11C10.5376 11 13 13.4624 13 16.5Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20C18 18.8954 18.8954 18 20 18C21.1046 18 22 18.8954 22 20Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 14H16C16.93 14 17.395 14 17.7765 14.1022C18.8117 14.3796 19.6204 15.1883 19.8978 16.2235C20 16.605 20 17.07 20 18" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 11V5C5 4.06812 5 3.60218 4.84776 3.23463C4.64477 2.74458 4.25542 2.35523 3.76537 2.15224C3.39782 2 2.93188 2 2 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 7H18" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 7V14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const VISUAL_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M22 8C22 8 18 14 12 14C6 14 2 8 2 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M15 13.5L16.5 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 11L22 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 13L4 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 13.5L7.5 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const HEARING_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M6.07692 18C6.07692 20.2091 7.226 22 9.30769 22C11.3894 22 13.0769 20.5 13.6154 18C13.8736 16.8013 14.4026 16.0767 15.2308 15.5C17.3846 14 19 11.6923 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 15C10.385 15 11.5078 13.9926 11.5078 12.75C11.5078 11.5074 10.385 10.5 9 10.5C9 8.48311 9.46383 6 12.0094 6C13.7998 6 14.8496 7.37416 15 9.15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const CAR_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M3.98173 17.5H2.47992C2.20345 17.5 1.98176 17.2775 2.00119 17.0021C2.05755 16.2028 2.25918 14.591 2.98052 13.2888C3.34135 12.6373 3.83222 12.0634 4.5 11.7073M2.98052 13.2888C2.98052 10.144 3.89594 6.34904 5.72678 4.71122C5.88815 4.56686 6.10124 4.5 6.31787 4.5H11.1118C11.6911 4.5 12.2694 4.6171 12.7553 4.93222C13.9539 5.70953 15.7652 7.27971 17.3038 9.68934C17.4311 9.88859 17.6211 10.0398 17.8435 10.1204C18.7292 10.4415 19.7153 10.887 20.3463 11.1839C20.7723 11.3844 21.1116 11.7341 21.273 12.176C21.7174 13.393 21.9682 14.7508 22 16.9994C22.0038 17.2755 21.7793 17.5 21.5028 17.5H20.001M15.9962 17.5H7.98654" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 17.5C8 18.6046 7.10457 19.5 6 19.5C4.89543 19.5 4 18.6046 4 17.5C4 16.3954 4.89543 15.5 6 15.5C7.10457 15.5 8 16.3954 8 17.5Z" stroke="white" strokeWidth="1.5" />
    <path d="M20 17.5C20 18.6046 19.1046 19.5 18 19.5C16.8954 19.5 16 18.6046 16 17.5C16 16.3954 16.8954 15.5 18 15.5C19.1046 15.5 20 16.3954 20 17.5Z" stroke="white" strokeWidth="1.5" />
    <path d="M17.5 10C14.5 9 11 8.5 7 9C7 7 8 5 8.5 4.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 11H9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const STETHOSCOPE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M13.0014 2C14.1053 2 15.0003 2.93126 15.0003 4.08003C15.0003 5.02915 15.0362 5.87375 14.2692 6.57196C11.7587 8.85732 10.5034 10 9.00027 10C7.49714 10 6.24187 8.85732 3.73133 6.57196C2.96426 5.87369 3.00027 5.029 3.00027 4.07981C3.00027 2.93116 3.8951 2 4.99893 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 14V17.4998C9 19.9852 11.0149 22.0001 13.5003 22.0001C15.9858 22.0001 18.0007 19.9852 18.0007 17.4998V16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 7L12.6978 10.2556C12.3516 11.121 12.1785 11.5537 11.8887 11.9092C11.5988 12.2648 11.2098 12.5215 10.4319 13.0349L8.9696 14L7.53283 13.0323C6.77221 12.5201 6.39189 12.2639 6.10821 11.9126C5.82452 11.5613 5.65423 11.1356 5.31365 10.2841L4 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 13C21 14.6569 19.6569 16 18 16C16.3431 16 15 14.6569 15 13C15 11.3431 16.3431 10 18 10C19.6569 10 21 11.3431 21 13Z" stroke="white" strokeWidth="1.5" />
    <path d="M18.125 13H18M18.25 13C18.25 13.1381 18.1381 13.25 18 13.25C17.8619 13.25 17.75 13.1381 17.75 13C17.75 12.8619 17.8619 12.75 18 12.75C18.1381 12.75 18.25 12.8619 18.25 13Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const BUILDING_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M16 10L18.1494 10.6448C19.5226 11.0568 20.2092 11.2628 20.6046 11.7942C21 12.3256 21 13.0425 21 14.4761V22" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M8 9H11M8 13H11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 22V19C12 18.0572 12 17.5858 11.7071 17.2929C11.4142 17 10.9428 17 10 17H9C8.05719 17 7.58579 17 7.29289 17.2929C7 17.5858 7 18.0572 7 19V22" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M2 22H22" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 22V6.71724C3 4.20649 3 2.95111 3.79118 2.32824C4.58237 1.70537 5.74742 2.04355 8.07752 2.7199L13.0775 4.17122C14.4836 4.57937 15.1867 4.78344 15.5933 5.33965C16 5.89587 16 6.65344 16 8.16857V22" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const HAND_HELPING_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M2 14.5V8.5C2 8.03501 2 7.80252 2.05111 7.61177C2.18981 7.09413 2.59413 6.68981 3.11177 6.55111C3.30252 6.5 3.53501 6.5 4 6.5C4.46499 6.5 4.69748 6.5 4.88823 6.55111C5.40587 6.68981 5.81019 7.09413 5.94889 7.61177C6 7.80252 6 8.03501 6 8.5V14.5C6 14.965 6 15.1975 5.94889 15.3882C5.81019 15.9059 5.40587 16.3102 4.88823 16.4489C4.69748 16.5 4.46499 16.5 4 16.5C3.53501 16.5 3.30252 16.5 3.11177 16.4489C2.59413 16.3102 2.18981 15.9059 2.05111 15.3882C2 15.1975 2 14.965 2 14.5Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 7.5H7.76845C8.58101 7.5 9.38511 7.66505 10.132 7.98513L14.8574 10.0103C15.5506 10.3074 16 10.989 16 11.7431C16 12.4373 15.4373 13 14.7431 13H14.0986C13.3729 13 12.6538 12.8615 11.98 12.592L10.5 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 13H20.5749C21.362 13 22 13.638 22 14.4251C22 15.0613 21.5782 15.6205 20.9664 15.7953L15.7451 17.2871C15.2508 17.4283 14.7392 17.5 14.2251 17.5C13.7437 17.5 13.2645 17.4372 12.7994 17.3132L6 15.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const HOSPITAL_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M6 9V21H18V9C18 6.17157 18 4.75736 17.1213 3.87868C16.2426 3 14.8284 3 12 3C9.17157 3 7.75736 3 6.87868 3.87868C6 4.75736 6 6.17157 6 9Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 13V17C2 18.8856 2 19.8284 2.58579 20.4142C3.17157 21 4.11438 21 6 21V9C4.11438 9 3.17157 9 2.58579 9.58579C2 10.1716 2 11.1144 2 13Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 9V21C19.8856 21 20.8284 21 21.4142 20.4142C22 19.8284 22 18.8856 22 17V13C22 11.1144 22 10.1716 21.4142 9.58579C21 9 19.8856 9 18 9Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 18V21H14V18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.0009 7V11M14.0059 8.995H10.0059" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const PEOPLE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M13 11C13 8.79086 11.2091 7 9 7C6.79086 7 5 8.79086 5 11C5 13.2091 6.79086 15 9 15C11.2091 15 13 13.2091 13 11Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.0386 7.55773C11.0131 7.37547 11 7.18927 11 7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C14.2554 11 13.5584 10.7966 12.9614 10.4423" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 21C15 17.6863 12.3137 15 9 15C5.68629 15 3 17.6863 3 21" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M21 17C21 13.6863 18.3137 11 15 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const HEART_HANDSHAKE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M19.6692 14.1693C21.01 12.463 22 10.5686 22 8.69451C22 5.82569 19.8947 3.50006 17 3.50006C15.5 3.50006 14 4.00006 12 6.00006C10 4.00006 8.5 3.50006 7 3.50006C4.10526 3.50006 2 5.82569 2 8.69451C2 13.7667 9.25143 18.9873 11.0835 20.2253C11.3541 20.4082 11.6734 20.5001 12 20.5001C12.3266 20.5001 12.6459 20.4082 12.9165 20.2253C13.0217 20.1542 13.1449 20.0699 13.2835 19.9733C14.2796 19.2789 14.3586 17.8586 13.5 17.0001" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M18.5 10.5001L19.49 11.4901C20.1988 12.1989 20.3483 13.295 19.7336 14.0868C18.9878 15.0475 17.5632 15.0633 16.7032 14.2033L16.5 14.0001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.5 14.0001L16.6942 14.1943C17.5691 15.0692 17.51 16.5616 16.5833 17.3812C15.7193 18.1455 14.4965 17.9966 13.6808 17.1808L13.5 17.0001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.0002 6.00006L9.25019 8.75006C8.55983 9.44042 8.55983 10.5597 9.25019 11.2501C9.94054 11.9404 11.0599 11.9404 11.7502 11.2501L13.5002 9.50006C14.0455 8.95481 14.3181 8.68219 14.6122 8.53645C15.1717 8.25917 15.8287 8.25917 16.3882 8.53645C16.6823 8.68219 16.955 8.95481 17.5002 9.50006L19.0002 11.0001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const BUS_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M14 3H10C7.17157 3 5.75736 3 4.87868 3.87868C4 4.75736 4 6.17157 4 9V19.25C4 19.9522 4 20.3033 4.16853 20.5556C4.24149 20.6648 4.33524 20.7585 4.44443 20.8315C4.69665 21 5.04777 21 5.75 21C6.45223 21 6.80335 21 7.05557 20.8315C7.16476 20.7585 7.25851 20.6648 7.33147 20.5556C7.5 20.3033 7.5 19.9522 7.5 19.25V19H16.5V19.25C16.5 19.9522 16.5 20.3033 16.6685 20.5556C16.7415 20.6648 16.8352 20.7585 16.9444 20.8315C17.1967 21 17.5478 21 18.25 21C18.9522 21 19.3033 21 19.5556 20.8315C19.6648 20.7585 19.7585 20.6648 19.8315 20.5556C20 20.3033 20 19.9522 20 19.25V9C20 6.17157 20 4.75736 19.1213 3.87868C18.2426 3 16.8284 3 14 3Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 6H14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 7L2 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 7L22 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 13H20" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 16H8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 16H17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const HAND_HEART_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M15.2053 10.7181C13.7947 9.60121 11 7.0478 11 4.74998C11 3.23121 12.0526 2 13.5 2C14.25 2 15 2.2647 16 3.32352C17 2.2647 17.75 2 18.5 2C19.9474 2 21 3.23121 21 4.74998C21 7.0478 18.2053 9.60121 16.7947 10.7181C16.32 11.094 15.68 11.094 15.2053 10.7181Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 19V13C2 12.535 2 12.3025 2.05111 12.1118C2.18981 11.5941 2.59413 11.1898 3.11177 11.0511C3.30252 11 3.53501 11 4 11C4.46499 11 4.69748 11 4.88823 11.0511C5.40587 11.1898 5.81019 11.5941 5.94889 12.1118C6 12.3025 6 12.535 6 13V19C6 19.465 6 19.6975 5.94889 19.8882C5.81019 20.4059 5.40587 20.8102 4.88823 20.9489C4.69748 21 4.46499 21 4 21C3.53501 21 3.30252 21 3.11177 20.9489C2.59413 20.8102 2.18981 20.4059 2.05111 19.8882C2 19.6975 2 19.465 2 19Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 12H7.76845C8.58101 12 9.38511 12.165 10.132 12.4851L14.8574 14.5103C15.5506 14.8074 16 15.489 16 16.2431C16 16.9373 15.4373 17.5 14.7431 17.5H14.0986C13.3729 17.5 12.6538 17.3615 11.98 17.092L10.5 16.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 17.5H20.5749C21.362 17.5 22 18.138 22 18.9251C22 19.5613 21.5782 20.1205 20.9664 20.2953L15.7451 21.7871C15.2508 21.9283 14.7392 22 14.2251 22C13.7437 22 13.2645 21.9372 12.7994 21.8132L6 20" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const SUPPORT_AREAS: readonly InfoItem[] = [
  {
    title: "Mobility",
    body: "Wheelchairs, crutches, and accessibility retrofits for people with limb weakness, and other mobility impairments.",
    icon: MOBILITY_ICON,
  },
  {
    title: "Visual",
    body: "Large-print materials, white canes, and eye-care partnerships for partial sight and low-vision beneficiaries.",
    icon: VISUAL_ICON,
  },
  {
    title: "Hearing",
    body: "Hearing aids, sign-language tutoring, and visual-alert tools for children and adults with hearing loss.",
    icon: HEARING_ICON,
  },
  {
    title: "Limb difference",
    body: "Prosthetics, adaptive tools, and skills training that turns ability into income — from tailoring to tech.",
    icon: MOBILITY_ICON,
  },
]

const PROVISIONS: readonly InfoItem[] = [
  { title: "Assistive devices", body: "Wheelchairs, hearing aids, prosthetics, white canes, braces, and adaptive tools.", icon: CAR_ICON },
  { title: "Medical & therapy", body: "Physiotherapy, occupational therapy, eye care, and specialist reviews", icon: STETHOSCOPE_ICON },
  { title: "School & university fees", body: "Tuition, books, hostel costs, and accessibility adjustments at school or campus.", icon: <GraduationCapIcon className="h-6 w-6" /> },
  { title: "Accessibility retrofits", body: "Ramps, rails, accessible toilets, and classroom or workspace modifications.", icon: BUILDING_ICON },
  { title: "Adapted skills training", body: "Vocational and digital skills tailored for accessibility and local markets.", icon: HAND_HELPING_ICON },
  { title: "Transport stipends", body: "Reliable transport to school, therapy, training, or work when mobility is costly.", icon: BUS_ICON },
]

const STAGES = [
  { label: "CHILDREN", ages: "5–12", body: "School access, early aids, therapy" },
  { label: "TEENS", ages: "13–17", body: "Secondary school, confidence, peer support" },
  { label: "UNIVERSITY STUDENTS", ages: "18–25", body: "Tuition, campus mobility, assistive tech" },
  { label: "ADULTS", ages: "26+", body: "Skills, employment tools, independence" },
]

const STORIES = [
  {
    tag: "MOBILITY",
    quote: "“I don't need someone to carry my books across campus. I need a wheelchair that keeps up with me.”",
    detail: "300-level political science student, now moving independently with a lightweight wheelchair and transport support.",
    name: "Emmanuel Obi",
  },
  {
    tag: "VISUAL",
    quote: "“I can still see enough to read — if the letters are large enough.”",
    detail: "JSS3 student receiving large-print materials and school-fee support; wants to study law.",
    name: "Grace Adaeze",
  },
  {
    tag: "LIMB DIFFERENCE",
    quote: "“The hook lets me finish hems faster. My customers don't even notice the difference.”",
    detail: "Tailor and business owner using a prosthetic hook and advanced skills training.",
    name: "Chinaza Nwosu",
  },
]

const WAYS_TO_HELP = [
  {
    title: "Sponsor a beneficiary",
    body: "Fund a specific person's devices, fees, or therapy and receive updates on their progress.",
    cta: "Start sponsorship",
    to: "/sponsor",
    icon: HEART_HANDSHAKE_ICON,
  },
  {
    title: "Donate a device",
    body: "New or refurbished wheelchairs, hearing aids, and prosthetic parts are always needed.",
    cta: "Offer a device",
    to: "/contact",
    icon: HAND_HEART_ICON,
  },
  {
    title: "Refer someone",
    body: "Know a child, student, or adult who needs support? Refer them to the Ability Program.",
    cta: "Refer now",
    to: "/nominate?program=ability",
    icon: PEOPLE_ICON,
  },
  {
    title: "Partner as a clinic",
    body: "Clinics, therapists, and hospitals can join our referral and service network.",
    cta: "Partner with us",
    to: "/contact",
    icon: HOSPITAL_ICON,
  },
]

function InfoCard({ title, body, icon, to, cta }: InfoItem & { to?: string; cta?: string }) {
  return (
    <article className="ability-info-card">
      <span className="ability-info-card__icon">
        {icon}
      </span>
      <div className="ability-info-card__content">
        <h3>{title}</h3>
        <p>{body}</p>
        {to && cta && (
          <Link to={to} className="ability-info-card__link">
            {cta}
            <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        )}
      </div>
    </article>
  )
}

function SectionHeading({ label, title, lede }: { label: React.ReactNode; title: React.ReactNode; lede?: React.ReactNode }) {
  return (
    <div className="ability-section-heading">
      <Eyebrow dot>{label}</Eyebrow>
      <h2>{title}</h2>
      {lede && <p>{lede}</p>}
    </div>
  )
}

export function AbilityProgramPage() {
  return (
    <div className="ability-program-page">
      <PageHero
        eyebrow="Ability Program"
        eyebrowDot
        title={<>Dignity, access, and opportunity — <span className="text-forest-700">for everybody.</span></>}
        lede="Redempta now supports people living with physical disabilities across every age: children, teens, university students, and adults. Mobility, visual, hearing, and limb-difference needs — met with devices, therapy, education, and skills."
        className="ability-program-hero"
      />

      <section className="ability-media-section">
        <div className="public-container">
          <div className="ability-media">
            <img src="/images/pages/about-ability.jpg" alt="Ability Program beneficiaries" />
            <div className="ability-media__overlay" />
            <div className="ability-reach">
              <p>CURRENT REACH</p>
              <p>8 beneficiaries</p>
              <p>Across Enugu, Anambra, Imo, and Lagos — with more referrals under review.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="ability-section ability-support-section">
        <div className="public-container">
          <SectionHeading label="Who We Support" title={<>Physical disabilities, <span className="text-forest-700">practical support.</span></>} />
          <div className="ability-card-grid ability-card-grid--support">
            {SUPPORT_AREAS.map((area) => <InfoCard key={area.title} {...area} />)}
          </div>
        </div>
      </section>

      <section className="ability-section ability-provisions-section">
        <div className="public-container">
          <SectionHeading label="What We Provide" title={<>More than a device — <span className="text-forest-700">a path forward.</span></>} />
          <div className="ability-card-grid ability-card-grid--provisions">
            {PROVISIONS.map((item) => <InfoCard key={item.title} {...item} />)}
          </div>
        </div>
      </section>

      <section className="ability-section ability-stages-section">
        <div className="public-container">
          <SectionHeading
             label={
               <>
                 <span className="hidden lg:inline">For the Foundational Stages of Life</span>
                 <span className="lg:hidden">For Every Stage of Life</span>
               </>
             }
             title={<>Not just children. <span className="text-forest-700">People.</span></>}
             lede={
               <>
                 <span className="hidden lg:inline">A disability does not end at 18. Our support stretches from the classroom to the campus.</span>
                 <span className="lg:hidden">A disability does not end at 18. Our support stretches from the classroom to the campus, the workshop, and the workplace.</span>
               </>
             }
          />
          <div className="ability-stage-grid">
            {STAGES.map((stage) => (
              <article key={stage.label} className="ability-stage-card">
                <p>{stage.label}</p>
                <p>{stage.ages}</p>
                <p>{stage.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="ability-section ability-stories-section">
        <div className="public-container">
          <SectionHeading label="Stories" title="Ability in action." />
          <div className="ability-story-grid">
            {STORIES.map((story) => (
              <figure key={story.name} className="ability-story-card">
                <p>{story.tag}</p>
                <blockquote>{story.quote}</blockquote>
                <p>{story.detail}</p>
                <figcaption>{story.name}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="ability-section ability-help-section">
        <div className="public-container">
           <SectionHeading label="How to Help" title={<>Join the <span className="text-forest-700">Ability Program.</span></>} />
          <div className="ability-card-grid ability-card-grid--help">
            {WAYS_TO_HELP.map((way) => <InfoCard key={way.title} {...way} />)}
          </div>
        </div>
      </section>

      <section className="ability-cta-section">
        <div className="public-container">
          <div className="ability-cta">
            <img src="/images/pages/ability-cta.jpg" alt="" aria-hidden />
            <div className="ability-cta__overlay" />
              <div className="ability-cta__content">
                <h2>
                  Access is dignity
                  <br />
                  <span>Dignity changes everything.</span>
                </h2>
              <p>A single referral, device, or sponsorship can remove the barrier that keeps someone on the sidelines.</p>
              <div className="ability-cta__actions">
                <GoldPill to="/nominate?program=ability">Refer someone</GoldPill>
                <Link to="/contact" className="ability-cta__secondary-link">Partner with us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
